"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppContent = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = tslib_1.__importDefault(require("styled-components"));
const ui_common_components_1 = require("@desygner/ui-common-components");
const AppLoadingAnimation_1 = require("./AppLoadingAnimation");
const StyledWrapper = styled_components_1.default.div `
  display: flex;
  flex-flow: column;
  flex: 1;
  width: 100%;
  gap: ${({ theme }) => ui_common_components_1.utils.rem(theme.Spacing.Size.XSmall)};
  margin-bottom: ${({ theme, isEmbedded }) => isEmbedded ? 0 : ui_common_components_1.utils.rem(theme.Spacing.Size.Medium)};
  border-radius: ${({ theme }) => `${ui_common_components_1.utils.rem(theme.Border.Radius.Large)}`};
`;
function AppContent({ loadingMessage = [], loadingSlowMessage = [], loadingVideo, isLoading, isEmbedded = false, children, crop, objectFit, }) {
    const messages = (0, react_1.useMemo)(() => {
        const messageArray1 = Array.isArray(loadingMessage)
            ? loadingMessage
            : [loadingMessage];
        const messageArray2 = Array.isArray(loadingSlowMessage)
            ? loadingSlowMessage
            : [loadingSlowMessage];
        return [...messageArray1, ...messageArray2];
    }, [loadingMessage, loadingSlowMessage]);
    return ((0, jsx_runtime_1.jsx)(StyledWrapper, { isEmbedded: isEmbedded, children: isLoading ? ((0, jsx_runtime_1.jsx)(AppLoadingAnimation_1.AppLoadingAnimation, { isLoading: isLoading, crop: crop, loadingVideo: loadingVideo, loadingMessage: messages, objectFit: objectFit })) : (children) }));
}
exports.AppContent = AppContent;
//# sourceMappingURL=AppContent.js.map